import { fetchClientGeneral } from './fetchClientGeneral';
import { patchClientGeneral } from './patchClientGeneral';
import { fetchClientContentEngine } from './fetchClientContentEngine';
import { patchClientContentEngine } from './patchClientContentEngine';
import { fetchClientProvider } from './fetchClientProvider';
import { fetchClientStudentManagement } from './fetchClientStudentManagement';
import { fetchClientExcursionManagement } from './fetchClientExcursionManagement';
import { fetchClientExcursionManagementVendorsList } from './fetchClientExcursionManagementVendorsList';

export default {
  patchClientGeneral,
  fetchClientGeneral,
  fetchClientContentEngine,
  patchClientContentEngine,
  fetchClientProvider,
  fetchClientStudentManagement,
  fetchClientExcursionManagement,
  fetchClientExcursionManagementVendorsList
};
